import {
	ReactElement,
	Ref,
	forwardRef,
	useEffect
} from "react";
import { Anchor, NavigationLinkProps } from "client/Components";
import { createBrowserNavigationUrl } from "client/Navigation/backwardCompatibility";

export const SubNavigationLink = forwardRef(
	(props: NavigationLinkProps, ref: Ref<HTMLAnchorElement>): ReactElement => {
		const {
			navigation,
			options,
			...anchorProps
		} = props;

		const href: string = createBrowserNavigationUrl(navigation);

		useEffect(
			(): void => {
				if (!options) {
					return;
				}

				console.error("Navigation options are not supported by the AnchorNavigationLink component and will be ignored");
			},
			[options]
		);

		return (
			<Anchor
				{...anchorProps}
				ref={ref}
				href={href}
			/>
		);
	}
);
SubNavigationLink.displayName = "SubNavigationLink";